import { createContext, useContext } from 'react';

type RecCompSelectionContextValue = {
  openSimilarityScoreWeightingModal: () => void;
  openColumnSettings: () => void;
  openQualityTierBreakdown: () => void;
  openFilterDrawer: () => void;
};

const RecCompSelectionContext = createContext<RecCompSelectionContextValue | null>(null);

export const RecCompSelectionProvider = RecCompSelectionContext.Provider;

export const useRecCompSelectionContext = (): Partial<RecCompSelectionContextValue> =>
  // Returns partial so callers in the rental flow (no provider) get undefined gracefully.
  useContext(RecCompSelectionContext) ?? {};
